import { ContactAction, ContactActions } from "../actions/contact-actions";

const INITIAL_STATE: Object = {
    contact: undefined,
};

export function contactsReducer(state: Object = INITIAL_STATE, action: ContactAction) {
    switch (action.type) {
        case ContactActions.GET_CONTACT_SUCCESS:
            return { ...state, contact: action.payload };

        default:
            return state;
    }
}
